<template>
  <Pie v-if="chartData" :data="chartData" :options="options" />
</template>

<script>
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import { Pie } from 'vue-chartjs'
import getOptionsAndData from './chart_config/pie_categorization_options.js'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
  name: 'ChartPie',
  components: {
    Pie,
  },
  props: {
    idEnterprise: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      chartData: null,
      options: null,
    }
  },
  async mounted() {
    try {
      const { chartData, options } = await getOptionsAndData(this.idEnterprise)
      this.chartData = chartData
      this.options = options
    } catch (error) {
      console.error('Erro ao carregar dados do gráfico:', error)
    }
  },
}
</script>
